// src/utils/security.js

export const containsMaliciousContent = (value = "") => {
  if (!value) return false;

  const patterns = [
    // Script Tags
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,

    // HTML Tags
    /<\/?[a-z][\s\S]*>/gi,

    // javascript:
    /javascript:/gi,

    // Event Handlers
    /on\w+\s*=/gi,

    // Dangerous HTML
    /<iframe/gi,
    /<object/gi,
    /<embed/gi,
    /<svg/gi,
    /<img/gi,
    /<link/gi,
    /<meta/gi,
    /<style/gi,
    /<base/gi,
    /<form/gi,
    /<input/gi,
    /<textarea/gi,

    // JS Functions
    /alert\s*\(/gi,
    /confirm\s*\(/gi,
    /prompt\s*\(/gi,
    /eval\s*\(/gi,
    /Function\s*\(/gi,
    /fetch\s*\(/gi,
    /XMLHttpRequest/gi,
    /document\./gi,
    /window\./gi,
    /localStorage/gi,
    /sessionStorage/gi,

    // SQL Injection
    /\bSELECT\b/gi,
    /\bINSERT\b/gi,
    /\bUPDATE\b/gi,
    /\bDELETE\b/gi,
    /\bDROP\b/gi,
    /\bUNION\b/gi,
    /\bALTER\b/gi,
    /\bCREATE\b/gi,
    /\bEXEC\b/gi,
    /\bEXECUTE\b/gi,
    /\bTRUNCATE\b/gi,
    /\bINFORMATION_SCHEMA\b/gi,
    /--/g,
    /;/g,
    /\/\*/g,
    /\*\//g,

    // Template Injection
    /\{\{.*?\}\}/g,
    /\$\{.*?\}/g,
  ];

  return patterns.some((pattern) => pattern.test(value));
};
